"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryTag = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _useStyles = require("../../helpers/useStyles");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

(0, _loadStyles.default)(".c5f1c58e8{display:inline-flex;align-items:center;height:1.125rem;box-sizing:border-box;max-width:100%;border-radius:.25rem;padding:0 .375rem;font-size:.75rem;font-weight:500;line-height:1rem}.c705d01f5{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.cdd5569f8.c945c5f12{background:var(--color-gray-20);color:var(--color-gray-90)}.cdd5569f8.c84e3f195{background:var(--color-blue-50);color:var(--color-blue-d)}.cdd5569f8.c29a84368{background:var(--color-green-50);color:var(--color-green-d)}.cdd5569f8.cfcabca93{background:var(--color-yellow-50);color:var(--color-orange-d)}.cdd5569f8.cf99c6011{background:var(--color-red-50);color:var(--color-red-d)}.c269f2139{text-transform:uppercase;border:.0625rem solid}.c269f2139.c945c5f12{border-color:var(--color-gray-30);color:var(--color-gray-80)}.c269f2139.c84e3f195{border-color:var(--color-blue-60);color:var(--color-blue-90)}.c269f2139.c29a84368{border-color:var(--color-green-60);color:var(--color-green-90)}.c269f2139.cfcabca93{border-color:var(--color-yellow-50);color:var(--color-orange-90)}.c269f2139.cf99c6011{border-color:var(--color-red-60);color:var(--color-red-90)}");
var styles = {
  root: 'c5f1c58e8',
  inner: 'c705d01f5',
  '--view-filled': 'cdd5569f8',
  '--color-gray': 'c945c5f12',
  '--color-blue': 'c84e3f195',
  '--color-green': 'c29a84368',
  '--color-yellow': 'cfcabca93',
  '--color-red': 'cf99c6011',
  '--view-stroked': 'c269f2139'
};

var SecondaryTag = function SecondaryTag(props) {
  var children = props.children,
      classes = props.classes,
      view = props.view,
      color = props.color,
      rootStyle = props.rootStyle;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, cn.view[view], cn.color[color]),
    style: rootStyle
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.inner
  }, children));
};

exports.SecondaryTag = SecondaryTag;
var view = ['filled', 'stroked'];
var color = ['gray', 'blue', 'green', 'yellow', 'red'];
SecondaryTag.modes = {
  view: view,
  color: color
};
SecondaryTag.propTypes = {
  /* component logic props */
  children: _propTypes.node.isRequired,

  /* styling modificators */
  view: (0, _propTypes.oneOf)(view),
  color: (0, _propTypes.oneOf)(color),

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles),
  rootStyle: _propTypes.object
};
SecondaryTag.defaultProps = {
  classes: {},
  rootStyle: {},
  view: 'filled',
  color: 'gray'
};